/* global axios */

import ApiClient from './ApiClient';

class HotelPortal extends ApiClient {
  constructor() {
    super('hotel_portal', { accountScoped: true });
  }

  hotels(city) {
    return axios.get(`${this.url}/hotels`, { params: { city } });
  }

  search(payload) {
    return axios.post(`${this.url}/search`, payload);
  }

  startSearch(payload, signal) {
    return axios.post(`${this.url}/searches`, payload, {
      signal,
      timeout: 12000,
    });
  }

  searchStatus(id, signal) {
    return axios.get(`${this.url}/searches/${id}`, { signal, timeout: 12000 });
  }

  manualQuote(payload) {
    return axios.post(`${this.url}/manual_quote`, payload);
  }

  competitorCheck(payload) {
    return axios.post(`${this.url}/competitor_check`, payload);
  }
}

export default new HotelPortal();
